var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('HomePic'),_c('BreadNav'),_c('div',{staticClass:"sub-main"},[_c('div',{staticClass:"right"},[_c('ProjectList',{attrs:{"col":3,"showTitle":false}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }